export default "__VITE_ASSET__03kJqMN9__"